<template>
  <Teleport to="#dialog">
    <transition appear name="fade">
      <div id="progress-dialog" class="dialog">
        <!-- message -->
        <div class="dialog-box">
          <div class="dialog-cancel" @click="handleClose">
            <i class="bi bi-x-circle-fill"></i>
          </div>
          <slot name="title">
            <div class="d-flex">
              <img v-if="!isFinish" src="@/assets/images/icon-notice.png" alt="" class="dialog-title-image" />
              <img v-else src="@/assets/images/icon-pass.png" alt="" class="dialog-title-image" />
              <p class="dialog-title">{{ title }}</p>
            </div>
          </slot>
          <slot name="body">
            <div class="dialog-body" v-html="text"></div>
            <cus-progress :progress="progress"></cus-progress>
          </slot>
          <slot name="footer">
            <div class="button-wrap">
              <cus-button text="關閉" color="blue" :width="30" @click="handleClose"></cus-button>
            </div>
          </slot>
        </div>
      </div>
    </transition>
  </Teleport>
</template>
<script>
import { defineAsyncComponent, computed, watch, ref } from 'vue';
import { useDownloadProgress, handleUpgradeStatus } from '@/utils/upgrade';
import store from '@/store';
export default {
  name: 'upgrade-alert',
  components: {
    CusProgress: defineAsyncComponent(() => import('@/library/CusProgress.vue')),
    CusButton: defineAsyncComponent(() => import('@/library/CusButton.vue')),
  },
  setup() {
    const visible = ref(true);
    const title = ref('正在下載安裝檔，可關閉視窗');
    const isFinish = ref(false);
    //取得版號
    const text = computed(() => store.getters['upgrade/getVersionText']);
    //取得下載進度
    const progress = computed(() => {
      if (store.getters['upgrade/getSoftwareStatus'] === 2) {
        return store.getters['upgrade/getFileSIze']?.current
          ? Math.floor(
              (store.getters['upgrade/getFileSIze']?.current / store.getters['upgrade/getFileSIze']?.total) * 100
            )
          : 0;
      } else if (store.getters['upgrade/getSoftwareStatus'] === 3) {
        return 100;
      } else {
        return 0;
      }
    });
    //為進度條設定每1秒打一次status api
    let timer;
    const setCheckSoftwareStatus = () => {
      store.dispatch('upgrade/checkSoftwareStatus');
      return setCheckSoftwareStatus;
    };
    const doSetCheckInterval = (time) => {
      timer && clearInterval(timer);
      timer = setInterval(setCheckSoftwareStatus(), time);
    };
    const clearCheckInterval = () => {
      clearInterval(timer);
    };
    doSetCheckInterval(1000);
    //關閉視窗
    const handleClose = () => {
      visible.value = false;
      clearCheckInterval();
      useDownloadProgress(false);
    };

    //監聽狀態
    watch(
      () => store.getters['upgrade/getSoftwareStatus'],
      () => {
        if (store.getters['upgrade/getSoftwareStatus'] === 2) return;
        else if (store.getters['upgrade/getSoftwareStatus'] === 3) {
          isFinish.value = true;
          title.value = '安裝檔已下載完畢';
          setTimeout(() => {
            if (visible.value) handleUpgradeStatus(3);
            handleClose();
          }, 3000);
        } else {
          handleClose();
        }
      }
    );

    return { title, isFinish, text, progress, handleClose };
  },
};
</script>
<style lang="scss" scoped>
.dialog {
  @include confirm-basic;
}
</style>
